import type { Option } from "../../shared/types/option";
import type { ChargesFilterFormValues } from "./types";
import { Values } from "../../shared/types/helpers";

export const CHARGE_LIST_QUERY_KEY = "charges-list";
export const CHARGE_QUERY_KEY = "charge";
export const HOME_CHARGES_QUERY_KEY = "home-charges";
export const OUTSTANDING_CHARGE_AMOUNT_QUERY_KEY = "charge-outstanding-amount";
export const HOME_CHARGES_LIMIT = 4;
export const CHARGES_COUNT_PER_PAGE = 15;
export const HOME_VISIBLE_CHARGE_STATUSES = ["Issued"] as const;
export const TENANT_VISIBLE_CHARGE_STATUSES = ["Issued", "Paid"] as const;

export const CHARGES_FILTER_FORM_DEFAULT_VALUES: ChargesFilterFormValues = {
  statuses: [],
  rentAreas: [],
  types: [],
};

export const CHARGE_STATUS_OPTIONS: Option[] = [
  {
    value: "Issued",
    label: "Выставлено",
  },
  {
    value: "Paid",
    label: "Оплачено",
  },
];

export const CHARGE_TYPE_OPTIONS: Option[] = [
  {
    value: "Rent",
    label: "Аренда",
  },
  {
    value: "Electricity",
    label: "Электроэнергия",
  },
  {
    value: "HotWater",
    label: "Горячая вода",
  },
  {
    value: "ColdWater",
    label: "Холодная вода",
  },
  {
    value: "Canalization",
    label: "Канализация",
  },
  {
    value: "Heating",
    label: "Отопление",
  },
  {
    value: "Other",
    label: "Прочее",
  },
  {
    value: "Gas",
    label: "Газ",
  },
];

export const CHARGE_LIST_SORT_FIELDS = {
  projectName: "ProjectName",
  unit: "Unit",
  chargeDate: "ChargeDate",
  dueDate: "DueDate",
  amount: "Amount",
} as const;

export type ChargeSortColumn = Values<typeof CHARGE_LIST_SORT_FIELDS>;
